export const ViewWordProps = {
  /**文件流 */
  stream: {},
};
